module.exports = __webpack_public_path__ + "static/media/IMG-6.a2231f60.jpg";